import Avatar from "components/common/Avatar";
import CardDropdown from "components/common/CardDropdown";
import Flex from "components/common/Flex";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";

import React, { useEffect, useState } from "react";
import { Card, Col, Dropdown, Row, Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import { DeleteDownloads, GetDownloads } from "api/endpoints";
import AddTeam from "./AddTeam";
import { formatDateTimetoDateStr } from "api/constants";
import IconButton from "components/common/IconButton";
import MEILoader from "components/ckeditor/MEILoader";
import DynamicPage from "components/dynamic-pages/DynamicPage";
import { toast } from "react-toastify";
import DeleteModal from "components/ckeditor/DeleteModal";
import AdvanceTableSearchBox from "components/common/advance-table/AdvanceTableSearchBox";
import { ExportToCSV } from "api/exports";


const Team = () => {

    const [downloads, setDownloads] = useState([]);
    const [loading, setLoading] = useState(false);


    const [key, setKey] = useState("downloads");

    const [editData, setEditData] = useState({});
    const [delData, setDelData] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);


    const columns = [
        {
            accessor: "none",
            Header: "",
            disableSortBy: true,
            cellProps: {
                className: "text-end",
                // style: {maxWidth: '45px'}
            },
            Cell: (row) => {
                return (

                    <div className="d-flex gap-1">
                        <IconButton icon='trash' size='sm' title='Delete' variant='danger' onClick={() => { setDelData(row.row.original.id); setDeleteModal(true) }}>
                        </IconButton>

                        <IconButton icon='edit' size='sm' title='Edit' onClick={() => { setEditData(row.row.original); setKey('adddownload') }}>

                        </IconButton>
                    </div>
                    // <CardDropdown>
                    //     <div className="py-2">
                    //         <Dropdown.Item href="#!">Edit</Dropdown.Item>
                    //         <Dropdown.Item href="#!">Delete</Dropdown.Item>
                    //     </div>
                    // </CardDropdown>
                );
            },
        },

        {
            accessor: "title",
            Header: "Title",
            headerProps: { className: "pe-1 text-900" },
            cellProps: {
                className: "py-2",
            },
            Cell: (rowData) => {
                const { title } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            <h5 className="mb-0 fs-10">{title}</h5>
                        </div>
                    </Flex>

                );
            },
        },
        {
            accessor: "description",
            Header: "Designation",
            headerProps: { className: "pe-1 text-900" },
            cellProps: {
                className: "py-2",
            },
            Cell: (rowData) => {
                const { description } = rowData.row.original;
                const Desc = JSON.parse(description)
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            <h5 className="mb-0 fs-10">{Desc.description}</h5>
                        </div>
                    </Flex>

                );
            },
        },
        {
            accessor: "order",
            Header: "Sequence Order",
            headerProps: { className: "pe-1 text-900" },
            cellProps: {
                className: "py-2",
            },
            Cell: (rowData) => {
                const { order } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            <h5 className="mb-0 fs-10">{order}</h5>
                        </div>
                    </Flex>

                );
            },
        },


        {
            accessor: "status",
            Header: "Status",
            headerProps: { className: "text-900" },
            Cell: (rowData) => {
                const { status } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            {status ?
                                <h5 className="mb-0 fs-10 text-success">PUBLISHED</h5>
                                :
                                <h5 className="mb-0 fs-10 text-danger">UN-PUBLISHED</h5>
                            }
                        </div>
                    </Flex>

                );
            },
        },

        {
            accessor: "createdBy",
            Header: "Created By/On",
            headerProps: { className: "text-900" },
            Cell: (rowData) => {
                const { createdOn, createdBy } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            <h5 className="mb-0 fs-10">{createdBy}</h5>
                            <h5 className="mb-0 fs-10 text-secondary">{formatDateTimetoDateStr(createdOn)}</h5>
                        </div>
                    </Flex>
                );
            },
        },
        {
            accessor: "modifiedBy",
            Header: "Modified By/On",
            headerProps: { className: "text-900" },
            Cell: (rowData) => {
                const { modifedOn, modifiedBy } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            <h5 className="mb-0 fs-10">{modifiedBy}</h5>
                            <h5 className="mb-0 fs-10 text-secondary">{formatDateTimetoDateStr(modifedOn)}</h5>
                        </div>
                    </Flex>
                );
            },
        },

    ];

    const fetchDownloads = () => {
        setLoading(true)
        GetDownloads(4).then(res => {

            setDownloads(res?.data?.data);
            setLoading(false)

        }).catch(err => {
            setLoading(false)
            console.log(err, 'GetDownloadsAPIError')
        })

    };

    useEffect(() => {
        fetchDownloads();

    }, []);


    const deleteData = () => {
        setDeleteModal(false);
        setLoading(true);
        DeleteDownloads(delData).then(res => {
            toast.success('Data deleted successfully.', {
                theme: "colored",
            });
            fetchDownloads();
        }).catch(err => {

            toast.error('Failed to delete data.', {
                theme: "colored",
            });
            setLoading(false);
        })
    }



    return (
        <>
            <div className="py-2 pt-0">
                <BreadCrumb />
            </div>

            <MEILoader showLoader={loading} />
            <DeleteModal show={deleteModal} hide={() => { setDeleteModal(false) }} deleteData={deleteData} />

            <Card className="mb-0">
                <Card.Header>
                    <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Core Team</h5>
                </Card.Header>
                {/* style={{ maxHeight: '70vh', minHeight: '70vh', overflow: 'auto' }} */}
                <Card.Body className="pt-0 p-3">
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => {
                            setKey(k);
                            if (k === 'downloads') {
                                setEditData({})
                            }
                        }}
                    >
                        <Tab
                            eventKey="downloads"
                            title="Core Team List"
                            className="border-bottom border-x "
                        >

                            <AdvanceTableWrapper
                                columns={columns}
                                data={downloads}
                                // dataLength={downloads.length}
                                // selection
                                sortable
                                pagination
                                perPage={100}
                            >

                                <Row className="flex-end-center mb-3 px-3" style={{ marginTop: -35 }}>
                                    <Col xs="auto" sm={5} lg={2} className="d-flex justify-content-end pe-0">
                                        <ExportToCSV
                                            columns={columns.slice(1)}
                                            data={downloads}
                                            filename={'Core Team'}
                                            statuses={['Published', 'Un-Published']}
                                        />
                                    </Col>
                                    <Col xs="auto" sm={6} lg={4}>
                                        <AdvanceTableSearchBox table placeholder="Search Anything..." />
                                    </Col>
                                </Row>
                                <div style={{ maxHeight: '58vh', minHeight: '58vh', overflow: 'auto' }}>
                                    <AdvanceTable
                                        table
                                        headerClassName="bg-200 text-nowrap align-middle sticky"
                                        rowClassName="align-middle white-space-nowrap"
                                        tableProps={{
                                            size: "sm",
                                            striped: true,
                                            className: "fs-10 mb-0 overflow-hidden",
                                        }}
                                    />
                                </div>
                                <AdvanceTableFooter
                                    rowCount={downloads.length || 0}
                                    table
                                    rowInfo
                                    // navButtons
                                    // rowsPerPageSelection
                                    navButtons
                                    className={'px-3 border-top'}
                                />
                            </AdvanceTableWrapper>



                        </Tab>


                        <Tab
                            eventKey="adddownload"
                            title={`${editData?.id ? 'Update' : 'Add'} Team Member`}
                            className="border-bottom border-x p-3"
                        >

                            <AddTeam editData={editData} handleDiscard={(reload = false) => {
                                setKey('downloads');
                                if (reload) {
                                    fetchDownloads();
                                }
                                setEditData({})
                            }} />
                        </Tab>


                        <Tab
                            eventKey="pagecontent"
                            title={'Page Content'}
                            className="border-bottom border-x p-3"
                        >
                            <DynamicPage defaulPageName={'cteam'} />
                        </Tab>


                    </Tabs>
                </Card.Body>
            </Card>


        </>
    );
};

export default Team;
